import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { filter, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class GalleryService {
  currentRoute: string[] = [];
  getUrl: string;
  postUrl: string;
  imgURl: string;

  constructor(public http: HttpClient, private router: Router) {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((x) => {
        this.currentRoute = x['url'].split('/');
        if (
          ['gallery', 'report'].includes(this.currentRoute.slice(-1)[0]) ||
          this.currentRoute[1].startsWith('report2')
        ) {
          this.getUrl = `/car/get/vehicle-gallery-data-info`;
          this.postUrl = `/car/add/vehicle-gallery-data-info`;
          this.imgURl = `storage/gallery/images/`;
        } else {
          this.getUrl = `/car/get/auction-gallery-data-info`;
          this.postUrl = `/car/add/auction-gallery-data-info`;
          this.imgURl = `storage/auction/images/`;
        }
      });
  }

  getGalleryPlaceholder() {
    return this.http.get(`${environment.api}/settings/get/gallery`);
  }

  getGallery(vid: string) {
    return this.http
      .post(`${environment.api}${this.getUrl}`, { vehicle_id: vid })
      .pipe(
        map((res: any) => ({
          ...res,
          imageUrl: this.imgURl,
        }))
      );
  }

  setGallery(data: Object) {
    return this.http.post(`${environment.api}${this.postUrl}`, data);
  }
}
